import { createContext, use } from "react"
import type { StoreId } from "./detect-store"

const StoreContext = createContext<StoreId | null | undefined>(undefined)

export function StoreProvider({
	store,
	children,
}: {
	store: StoreId | null
	children: React.ReactNode
}) {
	return <StoreContext value={store}>{children}</StoreContext>
}

export function useStoreId(): StoreId | null {
	const store = use(StoreContext)
	if (store === undefined) {
		throw new Error("useStoreId must be used within StoreProvider")
	}
	return store
}
